export const PROD_API_BASE_URL = "https://prod.api.memorang.io";
export const DEV_API_BASE_URL = "https://beta.api.memorang.io";
export const PROD_HUB_BASE_URL = "https://hub.memorang.com";
export const DEV_HUB_BASE_URL = "https://staging-hub.memorang.com";
export const PROD_CORE_URL = "https://memorang.com";

export const HUB_ENDPOINTS = {
	APP_CONFIGS: "/api/app-config",
	APP_CONFIG: (appId: string) => `/api/app-config/${appId}`,
	EXAM_CONTEXT: "/api/v2/ai/exam-context",
	GET_WAVEFORM_DATA: "/api/v2/ai/get-audio-waveform",
	ASSESSOR: "/api/v2/ai/graphs/assessor",
	ASSESSOR_AGENT: "/api/ai/v2/assessor",
	SESSION_ASSESSMENT_STATUS: "/api/ai/v2/session-assessment-status",
	FEEDBACK_AGENT: "/api/ai/v2/feedback",
	HINT: "/api/v2/ai/hint",
	FEEDBACK: "/api/v2/ai/submissions",
	TTS: "/api/v2/ai/tts",
	CACHE: "/api/v2/cache",
	USERS_ME: "/api/users/me",
	RECORDINGS_PRESIGN: "/api/recordings/presign",
	COPILOT_REDEEM: "/api/copilot/redeem",
	WORKFLOWS_SLACK_NOTIFICATION: "/api/workflows/slack-notification",
	SEND_EMAIL: "/api/v2/ai/send",
	RECOMMENDED_QUERIES: "/api/v2/ai/questions-beta",
	THREADS: "/api/v2/ai/threads",
	ASSISTANT_SESSION_REVIEW: "/api/v2/ai/assistant-session-review",
	SESSION_ANALYSIS: "/api/v2/ai/sessionAnalysis",
	SESSION_INSIGHTS: "/api/v2/ai/sessionInsights",
	TIPS: "/api/v2/ai/tips",
	GENERATE_CERTIFICATE: "/api/ai/generate-certificate",
	SEND_CERTIFICATE: "/api/ai/send-certificate",
} as const;

export const API_ENDPOINTS = {
	CUSTOMER_DELETION: "/customer/deletion",
	PRODUCT_DETAILS: "/aibl-query/get-product-details",
	PRODUCT_METADATA: "/aibl-query/get-product-metadata",
	COMMERCE_ACCESS_CODE: "/commerce/v1/access-code",
	COMMERCE_ACCESS_CODE_RESEND: "/commerce/v1/access-code/resend",
	COMMERCE_AUTH_EXTERNAL: "/commerce/v1/auth/external",
	COMMERCE_EXAM_LIST: "/commerce/v1/exam-list",
	COMMERCE_EXAM_DETAILS: "/commerce/v1/exam-details",
	COMMERCE_EXAM_META_DETAILS: "/commerce/v1/exam-meta-details",
	COMMERCE_PRODUCT_CHECKOUT: "/commerce/v1/product/checkout",
	BREAK_EVENTS: "/assessments/v1/responses/break-events",
	ANSWER_EVENTS: "/assessments/v1/responses/answer-events",
	SESSIONS: "/assessments/v1/sessions",
	SESSION_END: (sessionId: number) =>
		`/assessments/v1/sessions/${sessionId}/end`,
	SESSION_ITEMS: (sessionId: number) =>
		`/assessments/v1/sessions/${sessionId}/items`,
	SESSION_REPORTS: (sessionId: number) =>
		`/assessments/v1/sessions/${sessionId}/reports`,
	LEADERBOARD: "/assessments/v1/users/leaderboard",
	LEADERBOARD_RANK: (userId: number) =>
		`/assessments/v1/users/leaderboard/${userId}/rank`,
	DASHBOARD_ITEMS: "/assessments/v1/users/get-items-for-dashboard",
	USER_PROGRESS: "/assessments/v1/users/progress",
	USER_DOCUMENTS: "/assessments/v1/users/documents",
	ITEM_DISTRIBUTION: (userId: number) =>
		`/assessments/v1/users/${userId}/item-distribution`,
	USER_SESSIONS: (userId: number) => `/assessments/v1/users/${userId}/sessions`,
	USER_MIGRATED_STATUS: "/naplex-migration/naplex-user-assessment",
	FETCH_MIGRATION_STATUS: (userId: number) =>
		`/assessments/v1/users/${userId}/migrated-status`,
	CME_DETAILS: "/user-events/get-cme-details",
} as const;

export const JBJS_FULL_ARTICLE_URL =
	"https://www.jbjs.org/reader.php?rsuite_id=";
